import { Failure } from "../../../shared/failures/Failure";

export class MissingOrganizationFailure extends Failure {
  get message(): string {
    return "The user does not have an organization";
  }
}
